import React from 'react'

class HubspotForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }

  componentDidMount() {
    hbspt.forms.create({
      portalId: "6756189",
      formId: this.props.formId,
      target: `#${this.props.id}`,
      onFormSubmitted: () => {
        if (this.props.trackingId) {
          window.gtag('event', 'conversion', {
            'send_to': this.props.trackingId
          });
        }
      }
    });
  }
  render() { 
    return (
      <div id={this.props.id}></div>
    );
  }
}
 
export default HubspotForm;


// WEBPACK FOOTER //
// ./src/components/forms/HubspotForm.js